export enum Make {
  MAKE_TESLA = 'MAKE_TESLA',
}
export enum Model {
  MODEL_S = 'MODEL_S',
  MODEL_3 = 'MODEL_3',
  MODEL_X = 'MODEL_X',
  MODEL_Y = 'MODEL_Y',
}

export interface RiskProps {
  make?: Make;
  model?: Model;
  vin?: string;
}

export class Risk {
  make?: Make;
  model?: Model;
  vin?: string;

  constructor(props: RiskProps) {
    this.make = props.make;
    this.model = props.model;
    this.vin = props.vin;
  }
}
